
import { NewsArticlesSection } from "./NewsArticlesSection";
import { NewsFormSection } from "./NewsFormSection";
import { NewsArticle } from "./NewsManagement";

interface CategoryTabContentProps {
  title: string;
  articles: NewsArticle[];
  newArticle: Omit<NewsArticle, "id">;
  onChangeArticle: (article: Omit<NewsArticle, "id">) => void;
  onAddArticle: () => void;
  onDeleteArticle: (id: number) => void;
  onTogglePublic: (id: number) => void;
}

export function CategoryTabContent({
  title,
  articles,
  newArticle,
  onChangeArticle,
  onAddArticle,
  onDeleteArticle,
  onTogglePublic
}: CategoryTabContentProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      <NewsArticlesSection
        title={title}
        articles={articles}
        onDelete={onDeleteArticle}
        onTogglePublic={onTogglePublic}
      />
      
      <NewsFormSection
        article={newArticle}
        onChange={onChangeArticle}
        onSubmit={onAddArticle}
      />
    </div>
  );
}
